export const Heading: React.FC = (props) => (
  <div className="inline-flex items-center font-bold text-xl text-blue-600 bg-gray-200  rounded-full px-4 py-2 mb-3">
    {props.children}
  </div>
);
